module.exports = __webpack_public_path__ + "img/no-video-1.7724b5ca.png";